/** Decide activation only after a complete configuration passes validation. */
export function sendingToolEnabledAfterSave<T extends object>(input: {
  enabled: boolean
  initial: T
  values: T
  complete: boolean
}): boolean {
  if (!input.complete) return false
  const dirty = (Object.keys(input.values) as (keyof T)[])
    .some(key => input.values[key] !== input.initial[key])
  return input.enabled || dirty
}
